/* eslint-disable no-unused-vars */
export enum PaymentMethodProvider {
  SCRATCH_PAY = "SCRATCH_PAY",
  SQUARE = "SQUARE",
}

type BaseRenewalPreference = {
  currentSubscriptionId: string;
};

type SquareRenewalPreference = BaseRenewalPreference & {
  paymentMethodProvider: PaymentMethodProvider.SQUARE;
  newPlanId: number;
  cardId: string;
};

type ScratchPayRenewalPreference = BaseRenewalPreference & {
  paymentMethodProvider: PaymentMethodProvider.SCRATCH_PAY;
  scratchpayPlanId: number;
};

export type IAutoRenewalPreferenceInput<T extends PaymentMethodProvider = PaymentMethodProvider> =
  T extends PaymentMethodProvider.SQUARE
    ? SquareRenewalPreference
    : T extends PaymentMethodProvider.SCRATCH_PAY
    ? ScratchPayRenewalPreference
    : SquareRenewalPreference | ScratchPayRenewalPreference;

export interface IAutoRenewalPreferenceResponse {
  success: boolean;
  messages: string[];
}

export interface ICardDetails {
  cardId: string;
  last4Digits: string;
  cardBrand: string;
  expMonth: string;
  expYear: string;
}

export interface IAutoRenewalPreference {
  contactId: string;
  animalId: string;
  schemaName: string;
  currentSubscriptionId: string;
  newSubscriptionId: string;
  newPlanName: string;
  newPlanId: number;
  cardId: string;
  cardDetails: ICardDetails;
  newPlanType: string;
  newPlanStartDate?: string;
  squareCustomerId?: string;
  renewalStatus: string;
  newPlanEnrollmentFee?: number;
  newPlanSubscriptionFee?: number;
  paymentMethodProvider?: PaymentMethodProvider | null;
  scratchpayPlanId?: number | null;
}

export interface IGetAutoRenewalUserPreferencesResponse {
  success: boolean;
  messages: string[];
  preferences: IAutoRenewalPreference[];
}

export interface IGetAutoRenewalPreferenceResponse {
  success: boolean;
  messages: string[];
  preference: IAutoRenewalPreference;
}

export interface ICancelAutoRenewalPreferenceResponse {
  success: boolean;
  messages: string[];
}
